import {select} from "redux-saga/effects";
import {IApplicationState} from "../../index";
import {IAnswerStats} from "../../game/types";

export default function* () {
    const stats: IAnswerStats = yield select(({ questions, game }: IApplicationState) => game.questions[questions.currentQuestionId].answerStats);

    return stats.totalAnswerCount > 0
        && stats.stats.length;
}